<template>
    <div>
        <div>
            <div data-v-d8c6d368>
                <div data-v-d8c6d368="" class="el-card is-never-shadow">
                    <div class="el-card__body" style="padding: 10px;">
                        <div data-v-d8c6d368="" class="G_Field">
                            <div data-v-d8c6d368="" class="Label c_link" style="text-align: center;">
                                省份：
                            </div>
                            <div data-v-d8c6d368="" class="Fields">
                                <div data-v-d8c6d368="" class="row" v-if="zsq">
                                    <a data-v-d8c6d368="" class="city_link active">{{ shengname }}</a>
                                    <button data-v-d8c6d368="" type="button" @click="submit_zsq"
                                        class="el-button el-button--default el-button--mini is-round">
                                        <span>+ 更多省份</span>
                                    </button>
                                </div>
                                <div data-v-d8c6d368="" class="row" v-if="csq">
                                    <a data-v-d8c6d368="" class="city_link active">{{ shengname }}</a>
                                    <a data-v-d8c6d368="" v-for="sheng in shengfen" :href="'merchant?cid=' + sheng.id"
                                        :class="{ 'active': sheng.id === shengids }" class="city_link">{{ sheng.name
                                        }}</a>
                                    <div data-v-d8c6d368="" class="p-0" style="text-align: left;"><button
                                            data-v-d8c6d368="" @click="submit_csq" type="button"
                                            class="el-button el-button--default el-button--mini is-round"><span> -
                                                收起</span></button></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-v-d8c6d368="" class="el-card is-never-shadow">
                    <div class="el-card__body" style="padding: 10px;">
                        <div data-v-d8c6d368="" class="G_Field">
                            <div data-v-d8c6d368="" class="Label c_link" style="text-align: center;">
                                城市：
                            </div>
                            <div data-v-d8c6d368="" class="Fields">
                                <div data-v-d8c6d368="" class="row" v-if="zssq">
                                    <a data-v-d8c6d368="" class="city_link active">{{ chengshiname }}</a>
                                    <button data-v-d8c6d368="" @click="submit_zssq" type="button"
                                        class="el-button el-button--default el-button--mini is-round"><span> +
                                            更多城市</span></button>
                                </div>
                                <div data-v-d8c6d368="" class="row" v-if="cssq">
                                    <a data-v-d8c6d368="" class="city_link active">{{ chengshiname }}</a>
                                    <a data-v-d8c6d368="" v-for="shi in chengshi" :href="'merchant?cid=' + shi.id"
                                        :class="{ 'active': shi.id === chengshiids }" class="city_link">{{ shi.name
                                        }}</a>
                                    <div data-v-d8c6d368="" class="p-0" style="text-align: left;">
                                        <button data-v-d8c6d368="" @click="submit_cssq" type="button"
                                            class="el-button el-button--default el-button--mini is-round"><span> -
                                                收起</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div data-v-8875e6ba>
                <div data-v-8875e6ba class="el-row" style="z-index: 0;">
                    <div v-for="v in merchantdata" data-v-8875e6ba="" class="el-col el-col-24 el-col-xs-24 el-col-sm-12 el-col-md-8 el-col-lg-8">
                        <a data-v-8875e6ba="" :href="'merchantshow?id='+v.id" class="">
                            <div data-v-8875e6ba="" class="el-card is-hover-shadow"
                                style="margin: 0.1rem !important; overflow: hidden;">
                                <div class="el-card__body"><img data-v-8875e6ba="" alt="img"
                                        :src="v.img"
                                        onerror="this.remove()" class="Cover">
                                    <div data-v-8875e6ba="" class="C-InfoCard">
                                        <div data-v-8875e6ba="" class="Content">
                                            <div data-v-8875e6ba="" class="Title">{{v.title}}</div>
                                            <div data-v-8875e6ba="" class="Desc">{{v.ftitle}}</div>
                                            <div data-v-8875e6ba="" class="Location">
                                                <div data-v-8875e6ba="" class="Left"><svg data-v-73b7ef61=""
                                                        data-v-8875e6ba="" aria-hidden="true" class="svg-icon"
                                                        style="fill: rgb(255, 51, 153);">
                                                        <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
                                                    </svg> <span data-v-8875e6ba="">{{v.dz}}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div data-v-c4f3ece2>
                    <div data-v-c4f3ece2 class="el-card is-never-shadow" style="margin: 0px;">
                        <div class="el-card__body" style="margin: 20px;">
                        <el-pagination
                            background
                            layout="pager"
                            :total="total"
                            :pager-count="5"
                            @current-change="pageclick"
                            :page-size="24"
                            :current-page=currentpage
                            >
                        </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'merchant',
    data() {
        return {
            zsq: true,
            csq: false,
            zssq: true,
            cssq: false,

            shengname: '全部',
            shengids: null,
            shengfen: [],
            chengshiname: '全部',
            chengshiids: null,
            chengshi: [],

            merchantdata:[],

            total:null,
            currentpage:1,
        }
    },
    methods: {
        pageclick(pp){
            console.log(pp)
        },
        submit_zsq() {
            let shouqi = this.csq
            if (shouqi === false) {
                this.zsq = false
                this.csq = true
            }
        },
        submit_csq() {
            let zhankai = this.zsq
            if (zhankai === false) {
                this.zsq = true
                this.csq = false
            }
        },
        submit_zssq() {
            let chengshi = this.cssq
            if (chengshi === false) {
                this.cssq = true
                this.zssq = false
            }
        },
        submit_cssq() {
            this.cssq = false
            this.zssq = true
        }
    },
    mounted() {

        let cid = this.$route.query.cid

        let page = this.$route.query.page
        if (page) {
            page = Number(page)
            this.currentpage = Number(page)
        } else {
            page = 1
        }

        if (cid) {

            let shengtocid = cid.substr(0, 2) + '0000'
            this.shengids = Number(shengtocid)
            this.chengshiids = Number(cid)

            //当前cid是否存在0000
            let cidling = cid.indexOf('0000') !== -1
            if (cidling == true) {
                this.cssq = true
                this.zssq = false
            } else {
                this.cssq = false
                this.zssq = true
            }

            this.$http.post('/api/cityname',{cid:cid}).then(res=>{

                if (res.data.shiname) {
                    this.shengname = res.data.shengname
                    this.chengshiname = res.data.shiname
                } else {
                    this.shengname = res.data.shengname
                }

            })

            let cids = cid.indexOf('0000') !== -1
            if (cids === false) {
                //取cid前两位
                let shicids = cid.substr(0, 2) + '0000'

                this.$http.post('/api/selectCity',{cid:shicids}).then(res=>{
                    
                    this.chengshi = res.data

                })

            } else {

                this.$http.post('/api/selectCity',{cid:cid}).then(res=>{

                    this.chengshi = res.data

                })

            }

            this.$http.post('/api/merchant',{cid:cid,page:page}).then(res=>{
                
                this.merchantdata = res.data.data
                this.total = res.data.count

            })

        } else {

            this.$http.post('/api/merchant',{page:page}).then(res=>{
                
                this.merchantdata = res.data.data
                this.total = res.data.count

            })

        }

        this.$http.get('/api/province').then(res=>{
            
            this.shengfen = res.data

        })

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/merchant.vue